/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getSelectionEnd;
var _getGlobal = require("../../../../getGlobal");
var globalObject = (0, _getGlobal.getGlobal)();
var document = globalObject.document;
function getSelectionEnd(o) {
  if (o.createTextRange && !globalObject.getSelection) {
    var r = document.selection.createRange().duplicate();
    r.moveStart('character', -o.value.length);
    return r.text.length;
  }
  return o.selectionEnd;
}


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/Calendar/src/TimeInput/getSelectionEnd.js
// module id = 633
// module chunks = 0